// extracted by mini-css-extract-plugin
module.exports = {"orgName":"orgName__pulCN","contentTitle":"contentTitle__3k40-","warning":"warning__V3f6f"};